let actionTypes = {
  SET_LOADING: "SET_LOADING",
  SET_NAVIGATION: "SET_NAVIGATION",
  UPDATE_PROFILE_PIC: "UPDATE_PROFILE_PIC",
  SET_SELF: "SET_SELF",
};

export default actionTypes;
